import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { Building2, Clock, Users, Archive } from "lucide-react";
import OrgPending from "@/components/org/OrgPending";
import OrgMembers from "@/components/org/OrgMembers";
import OrgAudit from "@/components/org/OrgAudit";

const Stat = ({ icon: Icon, label, value, testid }) => (
  <Card className="p-4" data-testid={testid}>
    <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-slate-500 font-semibold"><Icon className="w-4 h-4 text-[#C9A961]" />{label}</div>
    <div className="font-serif text-3xl text-[#0A1F44] mt-1">{value ?? "—"}</div>
  </Card>
);

export default function OrgAdmin() {
  const { user, isReadOnly } = useAuth();
  const [summary, setSummary] = useState(null);
  const [members, setMembers] = useState([]);
  const [tick, setTick] = useState(0);
  const reload = useCallback(() => setTick((t) => t + 1), []);
  useEffect(() => {
    api.get("/org/summary").then((r) => setSummary(r.data)).catch((e) => toast.error(e?.response?.data?.detail || "Could not load organisation"));
    api.get("/org/users").then((r) => setMembers(r.data)).catch(() => {});
  }, [tick]);
  const leaders = [{ id: user?.id, name: `${user?.name} (you)`, upline_team: user?.upline_team }, ...members.filter((m) => ["leader", "team_leader", "platinum"].includes(m.role) && m.active)];
  return (
    <div className="space-y-6" data-testid="org-admin-page">
      <div>
        <div className="text-[11px] uppercase tracking-[0.24em] text-[#C9A961] font-semibold">Platinum Admin</div>
        <h1 className="font-serif text-3xl sm:text-4xl text-[#0A1F44] mt-1 break-words" data-testid="org-admin-title">{summary?.organisation || user?.name} organisation</h1>
        <p className="text-sm text-slate-600 mt-1">You can manage people in your own downline only. Changes are recorded in the audit log Sean & Rina can see.</p>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <Stat icon={Clock} label="Pending" value={summary?.pending_count} testid="org-stat-pending" />
        <Stat icon={Users} label="Members" value={summary?.members} testid="org-stat-members" />
        <Stat icon={Building2} label="Leaders" value={summary?.leaders} testid="org-stat-leaders" />
        <Stat icon={Archive} label="Archived" value={summary?.archived} testid="org-stat-archived" />
      </div>
      <OrgPending readOnly={isReadOnly} onChange={reload} tick={tick} />
      <OrgMembers readOnly={isReadOnly} leaders={leaders} onChange={reload} tick={tick} />
      <OrgAudit tick={tick} />
    </div>
  );
}
